export default function IntroSection() {
  const stats = [
    { value: "35,000+", label: "Stays managed" },
    { value: "1,000+", label: "Airbnb reviews" },
    { value: "5.0", label: "On Google (90+ reviews)" },
    { value: "16+", label: "UK cities" },
  ];

  return (
    <section style={{ backgroundColor: "#F4F1E7", padding: "clamp(60px,7vw,96px) clamp(20px,5vw,80px)" }}>
      <div style={{ maxWidth: 720, margin: "0 auto", textAlign: "center" }}>
        <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 11, fontWeight: 600, letterSpacing: "0.1em", textTransform: "uppercase", color: "#5C7268", marginBottom: 12, marginTop: 0 }}>
          Who we are
        </p>
        <h2 style={{ fontFamily: "'Inter', sans-serif", fontWeight: 700, fontSize: "clamp(28px, 4vw, 44px)", letterSpacing: "-0.02em", lineHeight: 1.15, color: "#112215", margin: "0 0 20px" }}>
          We're Truestays - your property, fully managed.
        </h2>
        <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 17, color: "#5C7268", lineHeight: 1.7, margin: "0 auto 40px", maxWidth: 580 }}>
          We're a full-service Airbnb and short-let management company looking after properties across the UK. From listing and pricing to guest communication, cleaning, and compliance - we handle every detail so you earn more, stress less, and never lift a finger.
        </p>
        <div style={{ display: "flex", justifyContent: "center", gap: 32, flexWrap: "wrap" }}>
          {stats.map((s) => (
            <div key={s.label} style={{ textAlign: "center" }}>
              <p style={{ fontFamily: "'Inter', sans-serif", fontWeight: 700, fontSize: 28, color: "#112215", margin: "0 0 4px" }}>{s.value}</p>
              <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 13, color: "#5C7268", margin: 0 }}>{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}